import { usePrivyAccount } from '@/hooks';
import { useAccountStore } from '@/store/use-account-store';

export function useAffiliateAuth() {
  const { address, authenticated, email } = usePrivyAccount();
  const hasPrimaryAuth = useAccountStore((state) => state.hasPrimaryAuth);

  return {
    address,
    authenticated,
    email,
    hasPrimaryAuth,
    isEnabled: authenticated && hasPrimaryAuth,
  };
}
